import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login-v2',
  templateUrl: './login-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginV2Component implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.openIDLogin();
  }
}
